// @ts-check

// GeoJSON data URLs
export const US_GEO_DATA = 'https://cdn.shipstation.com/geojson/us_states_geography.json';
export const WORLD_VIEW_DATA = 'https://cdn.shipstation.com/geojson/world_countries_geography.json';

// D3 projection names
export const D3Projections = {
  GeoAlbers: 'geoAlbers', // Continental US only
  GeoAlbersUsa: 'geoAlbersUsa', // US with Alaska and Hawaii
  GeoAzimuthalEqualArea: 'geoAzimuthalEqualArea', // Europe
  GeoEqualEarth: 'geoEqualEarth', // World view
};
